<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters } from "vuex";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Store",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Add New Stock",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Stock",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Item Name",
          sortable: true,
        },
        // {
        //   key: "amount",
        //   label: "Unit Price",
        //   sortable: true,
        // },
        {
          key: "quantity",
          label: "Quantity",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        item: "",
        quantity: "",
        amount: "",
      },
      totals: {
        date: new Date().toJSON().slice(0,10).replace(/-/g,'-'),
        by: "",
      },
      deletedata: {
        name: "",
        id: "",
      },
      editdata: {
        item: "",
        amount: "",
        quantity: "",
        id: "",
      },
      amountError: "",
      qtyError: "",
      itemError: "",
      modal: "",
      existing: [],
    };
  },
  computed: {
    ...mapGetters("inventory", [
      "StoreCart",
      "StoreItems",
      "SaveStatus",
    ]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.StoreCart ? this.StoreCart.length : 1;
    },
  },
  watch: {
    Saving(newValue) {
      if (newValue) {
        this.closeModal(this.modal);
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.StoreCart ? this.StoreCart.length : 1;
  },
  methods: {
    ...mapActions({
      FetchStoreItems: "inventory/fetchStoreItems",
      FetchStoreCart: "inventory/fetchStoreCart",
      AddToCart: "inventory/addCart",
      EditCart: "inventory/editCart",
      DeleteCart: "inventory/deleteCart",
      Submit: "inventory/submitCart",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.StoreCart ? this.StoreCart.length : 1;
      this.currentPage = 1;
    },

    // COMMA SEPERTOR FUNCTION
    thousandSeperater(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    checkExist() {
      //when creating a new one
      if (this.data.item != "") {
        this.existing = this.StoreCart
          ? this.StoreCart.filter((cart) => {
              return cart.itemId == this.data.item;
            })
          : [];
        if (this.existing.length) {
          this.itemError = "This item exists in the cart already";
        } else {
          this.itemError = "";
        }
      } else {
        this.existing = [];
      }
    },

    resetError() {
      this.qtyError = "";
      this.itemError = "";
    },

    resetModal() {
      this.data.item = "";
      this.data.quantity = "";
      this.resetError();
    },

    addToCart(modal) {
      if (this.data.quantity == "") {
        this.qtyError = "Quantity Purchased can't be empty";
        return;
      } else {
        this.qtyError = "";
      }
      if (this.data.item == "") {
        this.itemError = "Item field can't be empty'";
        return;
      } else {
        this.itemError = "";
      }
      if (this.existing.length > 0) {
        this.itemError = "This Item already Exists please'";
        return;
      } else {
        this.itemError = "";
      }
      this.modal = modal;
      this.AddToCart(this.data);
      this.resetError();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.editdata.id = values.item.id;
      this.editdata.amount = values.item.amount;
      this.editdata.item = values.item.itemId;
      this.editdata.quantity = values.item.quantity;
    },
    showDeleteModal(values) {
      this.deletedata.id = values.item.id;
      this.deletedata.name = values.item.name;
    },
    deleteCart(modal) {
      this.modal = modal;
      this.DeleteCart(this.deletedata);
      this.closeModal(modal);
    },
    editCart(modal) {
      if (this.editdata.quantity == "") {
        this.qtyError = "Quantity Brought can't be empty";
        return;
      } else {
        this.qtyError = "";
      }
      if (this.editdata.item == "") {
        this.itemError = "Store Item field can't be empty'";
        return;
      } else {
        this.itemError = "";
      }
      this.modal = modal;
      this.EditCart(this.editdata);
    },

    SubmitCart() {
      this.Submit(this.totals);
    },

    closeModal(modalId) {
        this.resetError();
        this.resetModal();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchStoreItems();
    this.FetchStoreCart();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('add_expenses')
        )
      "
    >
    <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <div class="form-group mb-3">
            <label>Store Item <span class="required">*</span></label>
            <div class="input-group">
                <model-list-select
                required
                :list="StoreItems ? StoreItems : []"
                v-model="data.item"
                option-value="id"
                option-text="name"
                class="mb-2"
                @input="resetError(), checkExist()"
                placeholder="Select Store Item"
                >
                </model-list-select>
            </div>
            <div class="text-danger" v-if="itemError">
                <em>{{ itemError }}</em>
            </div>
            </div>
            <div class="form-group mb-3">
            <label>Quantity Brought<span class="required">*</span></label>
            <div class="input-group">
                <input
                type="text"
                placeholder="Enter Quantity"
                class="form-control"
                @input="resetError()"
                v-model="data.quantity"
                @keyup.enter="addToCart()"
                />
            </div>
            <div class="text-danger" v-if="qtyError">
                <em>{{ qtyError }}</em>
            </div>
            </div>
            <div
                align="right"
                v-if="
                    getCurrentUser.permissions.find((item) =>
                    item.permission.includes('add_expenses')
                    )
                "
                >
                <button
                    type="button"
                    class="btn btn-outline-primary btn-sm"
                    @click="addToCart()"
                >
                    <i class="fa fa-check"></i> Add To Cart
                </button>
                </div>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">List of Items In Cart</h3>
              </div>
              <div class="col-3">
                <!-- <button
                  v-b-modal.add-modal
                  class="btn btn-primary float-end btn-sm"
                >
                  <i class="fa fa-plus"></i> Add To Cart
                </button> -->
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="StoreCart ? StoreCart : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                      size="sm"
                      variant="outline-primary"
                      v-b-modal.edit-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_expenses')
                        )
                      "
                      ><i class="fa fa-edit"></i> Edit</b-button
                    >
                    <b-button
                      size="sm"
                      variant="outline-danger"
                      v-b-modal.delete-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_expenses')
                        )
                      "
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </b-table>

            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <h3>Complete Cart Submission</h3>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                        <label>Brought By <span class="required">*</span></label>
                        <div class="input-group">
                            <input
                            type="text"
                            placeholder="Enter Person who brought the items"
                            class="form-control"
                            v-model="totals.by"
                            />
                        </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                        <label>Date Brought <span class="required">*</span></label>
                        <div class="input-group">
                            <input
                            type="date"
                            class="form-control"
                            v-model="totals.date"
                            @keyup.enter="SubmitCart()"
                            />
                        </div>
                        </div>
                    </div>
                    <div class="col-md-4"><br>
                        <div
                        align="right"
                        v-if="
                            getCurrentUser.permissions.find((item) =>
                            item.permission.includes('add_expenses')
                            )
                        "
                        >
                        <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            @click="SubmitCart()"
                        >
                            <i class="fa fa-check"></i> Submit Items
                        </button>
                        </div>
                    </div>
                </div>
          </div>
        </div>
      </div>
      

      <!-- modal starts -->
      <b-modal
        id="add-modal"
        hide-footer
        @hidden="resetAddModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_expenses')
          )
        "
      >
        <template #modal-title> Add Item To Cart </template>
        
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('add-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="addToCart('add-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_expenses')
          )
        "
      >
        <template #modal-title>
          Edit Item {{ editdata.name }}</template
        >
        <div class="form-group mb-3">
          <label>Store Item <span class="required">*</span></label>
          <div class="input-group">
            <select class="form-control" v-model="editdata.item" disabled>
              <option value="0" selected>All Items</option>
              <option
                v-for="(t, index) in StoreItems"
                :key="index"
                :value="t.id"
              >
                {{ t.name }}
              </option>
            </select>
          </div>
          <div class="text-danger" v-if="itemError">
            <em>{{ itemError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Quantity Brought <span class="required">*</span></label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Enter Quantity"
              class="form-control"
              @input="resetError()"
              v-model="editdata.quantity"
            />
          </div>
          <div class="text-danger" v-if="qtyError">
            <em>{{ qtyError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('edit-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="editCart('edit-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete fyear starts -->
      <b-modal
        id="delete-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_expenses')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">
            Delete {{ deletedata.name }} From Cart
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete {{ deletedata.name }} From Cart? Click
              Proceed Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-danger"
            @click="deleteCart('delete-modal')"
          >
            <i class="fa fa-trash"></i> Confirm</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.required {
  color: red;
}
</style>
